<template>
  <div class="reboot-table">
    <el-table :data="rebootModelTableData" border style="width: 100%" height="78vh">
      <el-table-column prop="stationName" label="设备" align="center"></el-table-column>
      <el-table-column prop="stationImei" label="序列号" align="center"></el-table-column>
      <el-table-column prop="dataPointName" label="数据点名称" align="center"></el-table-column>
      <el-table-column prop="alarmCondition" label="触发条件" align="center"></el-table-column>
      <el-table-column prop="created" label="创建时间" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.created, "YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column prop="alarmValue" label="触发值" align="center"></el-table-column>
      <!-- <el-table-column prop="robotName" label="确认状态" align="center"></el-table-column> -->
      <el-table-column prop="resumeTime" label="告警恢复" align="center">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.resumeTime, "YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="告警时长" align="center"></el-table-column>
      <!-- <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button title="编辑设备信息" @click="handleEdit(scope.row)" type="text" class="table-btn"><i class="el-icon-edit" style="color:#fff;font-size:1.5vh;"></i></el-button>
          <el-button title="删除设备" @click="deleteReboot(scope.row)" type="text" class="table-btn"><i class="el-icon-delete" style="color:#fff;"></i></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pager-class">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNumber" @current-change="handlePageChange(pageNumber)"></el-pagination>
    </div>
    <el-dialog class="my-dialog" :title="robotDialogTitle" :close-on-click-modal="false" :visible.sync="robotDialogVisible" @closed="closedDialog('deviceForm')">
      <el-form :model="deviceForm" :rules="deviceFormRules" ref="deviceForm">
        <el-form-item label="设备名称" :label-width="formLabelWidth" prop="deviceName">
          <el-input v-model.trim="deviceForm.deviceName" auto-complete="off" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属机器" :label-width="formLabelWidth" prop="robotMac">
          <el-select v-model.trim="deviceForm.robotMac" placeholder="请选择机器人">
            <el-option v-for="(item, index) in robotOption" :key="index" :label="item.name" :value="item.robotMac"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备序列号" :label-width="formLabelWidth" prop="deviceImei">
          <el-input v-model.trim="deviceForm.deviceImei" auto-complete="off" placeholder="请输入序列号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="机器Mac" :label-width="formLabelWidth" prop="robotMac">
          <el-input v-model.trim="deviceForm.robotMac" auto-complete="off" placeholder="请输入机器人Mac地址"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-button" @click="robotDialogVisible = false">取 消</el-button>
        <el-button class="save-button" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getAlarmsRecords } from "@/http/equipmentApi.js";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "rebootModelTable",
  components: {},
  data() {
    return {
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      rebootModelTableData: [],
      isAdd: true,
      robotDialogTitle: "添加设备",
      robotDialogVisible: false,
      formLabelWidth: "5vw",
      robotOption: [],
      allLinesOption: [],
      deviceForm: {
        deviceImei: "",
        deviceName: "",
        robotMac: ""
      },
      deviceFormRules: {
        deviceName: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        deviceImei: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        robotMac: [
          { required: true, message: "请输入机器人Mac地址", trigger: "blur" },
          {
            required: true,
            min: 11,
            max: 12,
            message: "机器人Mac地址为12位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState(["userMessage"])
  },
  methods: {
    dateFormat(stomp, type) {
      if (stomp == null) {
        return "";
      }
      return moment(stomp).format(type);
    },
    // 打开对话框
    showDialog() {
      this.robotDialogVisible = true;
    },
    // 关闭对话框时回调
    closedDialog(formName) {
      this.$refs[formName].clearValidate();
      this.isAdd = true;
      this.robotDialogTitle = "添加设备";
      this.deviceForm = {
        deviceImei: "",
        deviceName: "",
        robotMac: ""
      };
    },
    // 编辑按钮
    handleEdit(row) {
      this.deviceForm = JSON.parse(JSON.stringify(row));
      this.isAdd = false;
      this.robotDialogTitle = "修改设备信息";
      this.showDialog();
    },
    // 对话框保存按钮
    save() {
      if (this.isAdd) {
        this.addReboot();
      } else {
        this.updateReboot();
      }
    },
    // 添加设备
    addReboot() {
      let params = this.deviceForm;
      this.$refs.deviceForm.validate(valid => {
        if (valid) {
          addRebootModel(params)
            .then(res => {
              if (res.meta.code == 200) {
                this.$message.success(res.meta.msg);
                this.robotDialogVisible = false;
                this.getAlarmsRecordsTableData();
              } else {
                this.$message.warning(res.meta.msg);
              }
            })
            .catch(err => {
              if (err.status == 500) {
                this.$message.warning(err.data.data);
              }
            });
        }
      });
    },
    // 更新设备
    updateReboot() {
      let params = this.deviceForm;
      this.$refs.deviceForm.validate(valid => {
        if (valid) {
          updateRebootModel(params).then(res => {
            if (res.meta.code == 200) {
              this.$message.success(res.meta.msg);
              this.robotDialogVisible = false;
              this.getAlarmsRecordsTableData();
            } else {
              this.$message.error(res.meta.msg);
            }
          });
        }
      });
    },
    // 删除设备
    deleteReboot(row) {
      this.$confirm("此操作将永久删除设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(res => {
          console.log(res);
          deleteRebootModel({ id: row.id })
            .then(res => {
              if (res.meta.code == 200) {
                this.getAlarmsRecordsTableData();
                this.$message.success(res.meta.msg);
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err, "取消操作");
        });
    },
    // 获取表格数据
    getAlarmsRecordsTableData() {
      let params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      };
      getAlarmsRecords(params).then(res => {
        this.rebootModelTableData = res.rows;
        this.total = res.total;
      });
    },
    // 点击分页页码
    handlePageChange(pageNumber) {
      this.pageNumber = pageNumber;
      // 调用分页查询接口
      this.getAlarmsRecordsTableData();
    }
    // // 模糊查询机器人
    // searchRobot(keyWord) {
    //   let params = {
    //     pageNumber: this.pageNumber,
    //     pageSize: this.pageSize,
    //     condition: keyWord
    //   };
    //   getRobotFuzzy(params).then(res => {
    //     this.rebootModelTableData = res.rows;
    //     this.total = res.total;
    //   });
    // }
  },
  mounted() {
    this.getAlarmsRecordsTableData();
  }
};
</script>
<style lang="scss" scoped>
.pager-class {
  display: flex;
  justify-content: center;
}
</style>
